import React from "react"
import { Col, Row } from "react-bootstrap"

export default function SimpleCardRow({ name, value, className, title }) {

  return (
    <Row className={ className } title={ title }>
      <Col xs={3}><strong>{ name }</strong></Col>
      <Col xs={9}>
        { value }
        <hr/>
      </Col>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/SimpleCardRow.js